<template>
  <div class="info-message">
    <WIcon icon="icMagic" size="medium" class="info-message__icon" />
    <strong>{{ title }}: </strong>
    <WParagraph>
      <slot />
    </WParagraph>
  </div>
</template>
<script>
import { WIcon, WParagraph } from '@alice-health/wonderland-vue'
export default {
  components: {
    WIcon,
    WParagraph
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.info-message {
  display: flex;
  margin-top: var(--gl-spacing-04);
  color: var(--gl-color-shades-gray-70);
  font-size: var(--gl-font-size-xxs);

  &__icon {
    color: var(--gl-color-shades-magenta-60);
    flex: 0 0 auto;
    margin-right: var(--gl-spacing-02);
    margin-top: var(--gl-spacing-01);
  }

  strong {
    color: var(--gl-color-shades-magenta-60);
  }
}
</style>
